const momentMixin = {
  methods: {
    addWeekdays (date, days, WEEK_DAYS) {
      date.add('days', days)
      const weekday = date.isoWeekday()

      if (weekday <= WEEK_DAYS) return date

      if (days >= 0) {
        date.add('days', 7 - weekday + 1)
        return date
      }

      date.subtract('days', weekday - WEEK_DAYS)

      return date
    },

    // generate full DATETIME string based on custom DATE and TIME
    generateDateTime (date, time) {
      // convert 'end of day' to time
      const formattedTime = /^\d{2}:\d{2}$/.test(time) ? time : '23:59'

      const lessonDate = this.$dateFormat.date_yearlong(date)
      const fullDate = this.$moment(`${lessonDate} ${formattedTime}`, 'DD.MM.YYYY hh:mm')
      return this.$dateFormat.date_empty_format(fullDate)
    }
  }
}

export default momentMixin
